import { useState } from "react";

let _segId = 0;
const nextId = () => ++_segId;

/**
 * Manages the ordered list of split segments, each with a stable `id` so React
 * keys never rely on array index.
 */
export function useSegments(videoName, durationS) {
  const [segments, setSegments] = useState(() => [
    { id: nextId(), name: `${videoName} 1`, start: 0, end: durationS },
  ]);

  // Returns true if a split was made at time `t`, false if `t` was out of range.
  const splitAt = (t) => {
    const idx = segments.findIndex((s) => t > s.start + 0.5 && t < s.end - 0.5);
    if (idx === -1) return false;
    setSegments((prev) => {
      const seg = prev[idx];
      const first = { ...seg, end: t };
      const second = {
        id: nextId(),
        name: `${videoName} ${prev.length + 1}`,
        start: t,
        end: seg.end,
      };
      const next = [...prev];
      next.splice(idx, 1, first, second);
      return next;
    });
    return true;
  };

  const rename = (id, value) =>
    setSegments((prev) => prev.map((s) => (s.id === id ? { ...s, name: value } : s)));

  const undoSplit = (id) =>
    setSegments((prev) => {
      const i = prev.findIndex((s) => s.id === id);
      if (i <= 0) return prev;
      const next = [...prev];
      next[i - 1] = { ...next[i - 1], end: next[i].end };
      next.splice(i, 1);
      return next;
    });

  return { segments, splitAt, rename, undoSplit };
}
